"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _auth = require("@/utils/auth");
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'myShop',
  components: {
    Pagination: _Pagination.default
  },
  data: function data() {
    return {
      agentInfo: {},
      list: [],
      listLoading: true,
      listQuery: {
        start: 1,
        total: 10,
        page_num: 1
      }
    };
  },
  mounted: function mounted() {
    this.agentInfo = window.agentInfo;
    this.getList();
  },
  methods: {
    getList: function getList() {
      var _this = this;
      var url = 'agentapi/store/switch_store_list';
      var listQuery = Object.assign({}, this.listQuery, this.form, {
        start: this.listQuery.start - 1
      });
      this.$get(url, listQuery).then(function (res) {
        _this.listLoading = false;
        _this.list = res.list;
        _this.listQuery.page_num = res.page_num;
      }).catch(function () {
        _this.listLoading = false;
      });
    },
    /**
     * 铺货
     */
    switchShop: function switchShop(row) {
      var _this2 = this;
      this.$alert('确定切换到该商户吗？', '切换商户', {
        confirmButtonText: '确定',
        callback: function callback(action) {
          if (action == 'confirm') {
            _this2.$post('agentapi/store/switch_other_store', {
              store_id: row.id
            }).then(function (res) {
              _this2.$store.dispatch('user/postSetRecode', [4, 1, 2]);
              (0, _auth.setToken)(res.token);
              (0, _auth.setToken)(res.user_id, 'user_id');
              _this2.$message({
                message: '切换成功',
                type: 'success'
              });
              setTimeout(function () {
                location.href = '/shop/myShop';
              }, 2000);
            });
          }
        }
      });
    }
  }
};